/* jslint nomen: true */

'use strict';

var $ = require('jquery');

function progressbaranimation() {
    // Vars
    var current = $('.progress-bar').attr('data-progress-current');
    var total = $('.progress-bar').attr('data-progress-total');
    var percent = (current * 100) / total + '%';

    // Bar animation
    $('.progress-bar-container').animate({width: percent}, {duration: 1800});
}

function progressbar() {
    // Run on load
    $(window).on('load', function () {
        progressbaranimation();
    });
}

module.exports = {
    init: function () {
        progressbar();
    }
};
